@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

@mixin input-sizes($isInput: false) {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: v.$primary-font;
  font-style: normal;
  box-sizing: border-box;
  @include t.text(14px, 16px, 500);
  min-width: 15px;
  @if ($isInput) {
    width: 15px; //init width
    max-width: 100%;
  }
  padding: 5px;
}

.calcWidth {
  display: inline-block;
  position: absolute;
  top: -99999.9rem;
  left: -99999.9rem;
  border: 0;
  @include input-sizes();
}

.input {
  background-color: transparent;
  border: 0;
  outline: 0;

  @include input-sizes(true);

  color: v.$palette-gray-900;

  vertical-align: middle;
  margin: 4px 0;
}
